<template>
  <b-container fluid class="upload">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      type="border-card"
    >
      <el-tab-pane
        label="Upload"
        name="first"
      >
        <b-row>
          <div class="col-lg-12 col-md-12 mt-2">
            <span>Tipo de arquivo:</span>
            <br>
            <el-select
              clearable
              v-model="tipoEstoque"
              placeholder="Selecione o tipo de arquivo"
              v-if="isHavaianas"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              clearable
              v-model="tipoEstoque"
              placeholder="Selecione o tipo de arquivo"
              v-if="!isHavaianas && premiumUser"
            >
              <el-option
                v-for="item in [{
                  value: 0,
                  label: 'Processamento de dados'
                },
                {
                  value: 6,
                  label: 'Cadastro de usuários em lote'
                }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <transition name="slide-fade">
            <div class="col-lg-12 col-md-12 mt-2">
                <UploadItem :tipoArquivo="tipoEstoque"/>
            </div>
          </transition>
        </b-row>
      </el-tab-pane>
      <el-tab-pane
        label="Status"
        name="status"
        v-if="temAcesso('Arquivo','Obter')"
      >
        <b-row>
          <div class="col-lg-12 col-md-12 mt-2">
            <UploadStatus />
          </div>
        </b-row>
      </el-tab-pane>
    </el-tabs>
  </b-container>
</template>

<script>
import UploadItem from './UploadItem'
import UploadStatus from './UploadStatus'
import isHavaianas from '@/mixins/isHavaianas'

export default {
  components: {
    UploadItem,
    UploadStatus
  },
  data () {
    return {
      activeName: 'first',
      options: [{
        value: 0,
        label: 'Processamento de dados'
      },{
        value: 1,
        label: 'Entrada de estoque'
      }, {
        value: 2,
        label: 'Posição de estoque inicial'
      }, {
        value: 3,
        label: 'Posição de estoque final'
      }, {
        value: 4,
        label: 'Catálogo de preços'
      }, {
        value: 5,
        label: 'Ajuste de Estoque'
      },
      {
        value: 6,
        label: 'Cadastro de usuários em lote'
      }],
      tipoEstoque: 0,
    }
  },
  mixins: [isHavaianas],
  methods: {
    handleClick (tab) {
      if(tab.paneName === "status"){
        this.$root.$emit('tabStatus')
      }
    }
  }
}
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.upload .el-select .el-input {
    width: 250px;
}
</style>